export default __webpack_public_path__ + "static/media/kids-studying.2f2e5385.png";